import { EventItem } from 'queries/events/types';
import './style.scss';
import { useRenderCharts } from '../../hooks/useRenderChart';

interface ExpandedChartsModalProps {
  assetId: string;
  selectedRow: EventItem;
  charts: string[];
  activeTab: string;
}

export const ExpandedChartsModal = ({
  assetId,
  selectedRow,
  charts,
  activeTab,
}: ExpandedChartsModalProps) => {
  const showCharts = useRenderCharts({ assetId, selectedRow, charts, activeTab });
  return <div className="expanded-charts-modal">{showCharts}</div>;
};
